<template>
    <div class="jf_container yuyue">
        <div class="jf_conditionBox">
            <el-input placeholder="请输入家长手机号" v-model="p_phone" clearable></el-input>
            <el-select class="assort" v-model="state" placeholder="请选择状态" clearable>
                <el-option
                    v-for="item in stateOptions"
                    :key="item.type"
                    :label="item.t_name"
                    :value="item.type"
                ></el-option>
            </el-select>
            <el-button
                type="success"
                icon="el-icon-search"
                size="mini"
                @click="getTableData({page: 1})"
            >搜索</el-button>
            <el-button class="createBtn" type="success" size="mini" @click="handleAddQk">添加潜客</el-button>
        </div>
        <!-- 数据表格 -->
        <el-table
            class="elTable"
            :data="tableData"
            v-if="tableData.length>0"
            @select-all="handleSelectAll"
        >
            <el-table-column type="selection" width="55">
                <template slot-scope="scope">
                    <el-checkbox
                        v-if="!scope.row.saas_user_id"
                        v-model="scope.row.check"
                        @change="handleChangeSinle($event, scope.row.id)"
                    ></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column label="类型" header-align="center" min-width="70">
                <template slot-scope="scope">{{scope.row.type === 1 ? '测评预约' : '试听预约'}}</template>
            </el-table-column>
            <el-table-column
                prop="name"
                label="会员姓名"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="sex"
                label="会员性别"
                header-align="center"
                :show-overflow-tooltip="true"
                width="80"
            ></el-table-column>
            <el-table-column
                prop="birthday"
                label="会员生日"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="relation"
                label="家长关系"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="p_name"
                label="家长姓名"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="p_phone" label="家长电话" header-align="center" min-width="110"></el-table-column>
            <el-table-column
                prop="site"
                label="家庭住址"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="状态" header-align="center">
                <template
                    slot-scope="scope"
                >{{scope.row.status === 1 ? '待联系 ' : scope.row.status === 2 ?'已预约' : '不再联系'}}</template>
            </el-table-column>
            <el-table-column prop="create_time" label="预约时间" header-align="center" width="100"></el-table-column>
            <el-table-column
                prop="came_time"
                label="到店时间"
                header-align="center"
                :show-overflow-tooltip="true"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="notes"
                label="联系备注"
                header-align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" header-align="center" width="60">
                <template slot-scope="scope">
                    <el-button
                        @click="handleEdit(scope)"
                        type="text"
                        size="small"
                        style="color:#8CBB77"
                        v-if="scope.row.centre_id"
                    >处理</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination
            class="pageClass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.page*1"
            :page-sizes="[10, 20, 50]"
            :page-size="pageData.pagesize*1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.datatotal*1"
        ></el-pagination>

        <!-- 处理弹窗 -->
        <div class="myDialog" v-if="editDialog">
            <div class="myDialog_content rule_add">
                <h4 class="myDialog_h">
                    处理
                    <i
                        class="close el-icon-circle-close-outline el-icon-circle-close"
                        @click="editDialog=false"
                    ></i>
                </h4>
                <div class="dataRow">
                    <div>
                        <span class="popup-tip">会员姓名</span>
                        ：&nbsp;&nbsp;{{singleData.name}}
                    </div>
                    <div>
                        <span class="popup-tip">会员性别</span>
                        ：&nbsp;&nbsp;{{singleData.sex}}
                    </div>
                    <div>
                        <span class="popup-tip">会员生日</span>
                        ：&nbsp;&nbsp;{{singleData.birthday}}
                    </div>
                </div>
                <div class="dataRow">
                    <div>
                        <span class="popup-tip">家长关系</span>
                        ：&nbsp;&nbsp;{{singleData.relation}}
                    </div>
                    <div>
                        <span class="popup-tip">家长姓名</span>
                        ：&nbsp;&nbsp;{{singleData.p_name}}
                    </div>
                    <div>
                        <span class="popup-tip">家长电话</span>
                        ：&nbsp;&nbsp;{{singleData.p_phone}}
                    </div>
                </div>
                <div class="dataRow">
                    <div>
                        <span class="popup-tip">类型</span>
                        ：&nbsp;&nbsp;{{singleData.type === 1 ? '测评预约' : '试听预约'}}
                    </div>
                    <div>
                        <span class="popup-tip">家庭住址</span>：&nbsp;&nbsp;
                        <el-tooltip effect="dark" :content="singleData.site" placement="top">
                            <span class="addr">{{singleData.site}}</span>
                        </el-tooltip>
                    </div>
                    <div>
                        <span class="popup-tip">预约时间</span>：&nbsp;&nbsp;
                        <el-tooltip effect="dark" :content="singleData.create_time" placement="top">
                            <span class="addr">{{singleData.create_time}}</span>
                        </el-tooltip>
                    </div>
                </div>
                <hr />
                <!-- 可修改内容 -->
                <div class="edit-content" style="display:block">
                    <span class="popup-tip">联系结果</span>：&nbsp;&nbsp;
                    <el-radio v-model="singleData.status" :label="1">待联系</el-radio>
                    <el-radio v-model="singleData.status" :label="2">已预约</el-radio>
                    <el-radio v-model="singleData.status" :label="3">不在联系</el-radio>
                </div>
                <div class="edit-content">
                    <span class="popup-tip">到店时间</span>：&nbsp;&nbsp;
                    <el-date-picker
                        v-model="singleData.came_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    ></el-date-picker>
                </div>
                <div class="edit-content">
                    <span class="popup-tip">联系备注</span>：&nbsp;&nbsp;
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="请输入内容"
                        v-model="singleData.notes"
                    ></el-input>
                </div>
                <div class="btnWrap">
                    <button class="assort_confim-btn" @click="editDialog=false">取消</button>
                    <button class="assort_confim-btn confim" @click="handleSubmitRule">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "yuyue",
    data() {
        return {
            tableData: [],
            p_phone: "",
            state: "",
            stateOptions: [
                {
                    type: 1,
                    t_name: "待联系"
                },
                {
                    type: 2,
                    t_name: "已预约"
                },
                {
                    type: 3,
                    t_name: "不在联系"
                }
            ],
            pageData: {
                datatotal: "", // 总条数
                page: 1, // 当前页
                pagetotal: "", // 总页数
                pagesize: 10 // 每页数量
            }, // 页数
            editDialog: false,
            singleData: {},
            active_index: 0,
            multipleSelection: [], // 表格多选框
            isAdding: false // 防抖
        };
    },
    props: ["userAuthData"],
    created() {
        this.getTableData();
    },
    methods: {
        // 获取表格数据函数
        getTableData(argObj) {
            let params = {
                type: 2,
                phone: this.p_phone,
                state: this.state,
                page: this.pageData.page,
                pagesize: this.pageData.pagesize,
                operator: this.userAuthData.phone,
                access_token: "saas_system"
            };
            // 如果有传入修改的参数 则合并
            argObj && Object.assign(params, argObj);
            this.$http
                .post(
                    process.env.apiUrl + "saas/babo_api/query_appointment",
                    params
                )
                .then(res => {
                    if (res.code === 200) {
                        this.pageData = res.result.map;
                        this.tableData = res.result.data;
                        // 给数据增加一个 check 的属性让选择框使用
                        this.multipleSelection = [];

                        this.tableData.forEach((ele, i) => {
                            this.$set(this.tableData[i], "check", false);
                        });
                    }
                });
        },
        handleSizeChange(val) {
            this.pageData.pagesize = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pageData.page = val;
            this.getTableData();
        },
        // 处理 函数
        handleEdit(obj) {
            this.editDialog = true;
            Object.keys(obj.row).forEach(item => {
                this.$set(this.singleData, item, obj.row[item]);
            });
            this.active_index = obj.$index;
        },
        // 处理弹窗确认函数
        handleSubmitRule() {
            let params = {
                appointment_id: this.singleData.id,
                operator: this.userAuthData.phone,
                state: this.singleData.status,
                came_time: this.singleData.came_time,
                notes: this.singleData.notes,
                access_token: "saas_system"
            };
            this.$http
                .post(
                    process.env.apiUrl + "saas/babo_api/edit_appointment",
                    params
                )
                .then(res => {
                    if (res.code === 200) {
                        this.tableData[
                            this.active_index
                        ].status = this.singleData.status;
                        this.tableData[
                            this.active_index
                        ].came_time = this.singleData.came_time;
                        this.tableData[
                            this.active_index
                        ].notes = this.singleData.notes;
                        this.$message.success("修改成功");
                        this.editDialog = false;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
        },
        // 多选
        handleSelectAll(val) {
            this.multipleSelection = [];
            let checkStatus = val.length > 0 ? true : false;
            this.tableData.forEach((ele, i) => {
                ele.check = checkStatus;
                // 全选中 且  id 不在潜客中
                if (checkStatus && !ele.saas_user_id) {
                    this.multipleSelection.push(ele.id);
                }
            });
        },
        // 单选
        handleChangeSinle(val, id) {
            let i = this.multipleSelection.indexOf(id);
            if (val && i < 0) {
                this.multipleSelection.push(id);
            } else if (!val && i >= 0) {
                this.multipleSelection.splice(i, 1);
            }
        },
        // 新增潜客
        handleAddQk() {
            if (this.isAdding) {
                return;
            }
            if (this.multipleSelection.length === 0) {
                this.$message.error("请勾选添加到潜客的用户");
                return;
            }
            this.isAdding = true;
            this.$http
                .post(process.env.apiUrl + "saas/babo_api/add_saas_user", {
                    appointment_id: this.multipleSelection
                })
                .then(res => {
                    if (res.status === 1) {
                        this.$confirm(
                            `新增：${res.success}条<br/>用户已存在匹配成功：${res.error}条`,
                            res.msg,
                            {
                                confirmButtonText: "确定",
                                dangerouslyUseHTMLString: true,
                                type: "success",
                                showCancelButton: false
                            }
                        );
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .finally(() => {
                    this.isAdding = false;
                });
        }
    }
};
</script>
<style lang="less">
.yuyue.jf_container {
    .el-radio {
        // margin-bottom: 0;
        // height: 16px;
    }
    .el-table td,
    .el-table th {
        text-align: center !important;
    }
    .jf_conditionBox {
        display: flex;
        align-items: center;
        .el-input {
            margin-right: 40px;
            width: 180px;
        }
    }
    .number.active {
        color: #fff;
    }
}
</style>
<style scoped lang="less">
.jf_container {
    min-width: 1200px;
}
.jf_conditionBox {
    width: 100%;
    height: 60px;
    padding-left: 30px;
    background: #f5f5f5;
}
.elTable {
    width: 96%;
    margin: 20px 0 0 30px;
    text-align: center;
}

.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #8CBB77;
}
.close {
    float: right;
    margin: 8px 20px;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.pageClass {
    text-align: center;
    margin: 20px 0 50px;
}
.dataRow {
    display: flex;
    margin: 14px 0;
    width: 100%;
    & > div {
        width: 31%;
        margin-right: 14px;
        padding-left: 40px;
        font-size: 14px;

        .addr {
            display: inline-block;
            width: 90px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            vertical-align: middle;
        }
    }
    & > div:last-child {
        padding-left: 20px;
    }
}
.popup-tip {
    display: inline-block;
    width: 60px;
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
    font-weight: 600;
    font-size: 14px;
}
.edit-content {
    display: flex;
    padding-left: 40px;
    margin-top: 16px;
}
.createBtn {
    margin-left: auto;
    margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/yuyue/yuyue.vue